import axiosInstance from "../app/axios";

export const getPrivacyPoliciesApi = async () => {
  const result = await axiosInstance.get("settings/97");
  return result.data;
};

export const updatePrivacyPoliciesApi = async (setting: any) => {
  const result = await axiosInstance.put("settings/97", setting);
  return result.data;
};
